import Billboard from "../../components/Billboard/Billboard";

export default function MoviesPage() {
  return <Billboard />;
}
